import { toast } from 'react-toastify';
import { toast as globalToast, isToastReady } from '../components/ToastManager';

// The global toast has no toastId de-dupe, so repeats of the same key are skipped for this long.
const TOAST_DEDUPE_MS = 5000;
const lastToastAt = {};

const GLOBAL_TOAST_BY_TYPE = {
  success: 'showSuccess',
  info: 'showInfo',
  warning: 'showWarning',
  error: 'showError',
};

// Shows `message` in the app's global toast, or react-toastify before <ToastBridge> has mounted
// (e.g. during app start). Pass a dedupeKey to show a repeating message at most once per 5s.
export const notify = (type, message, dedupeKey) => {
  if (dedupeKey) {
    const now = Date.now();
    if (now - (lastToastAt[dedupeKey] || 0) < TOAST_DEDUPE_MS) return;
    lastToastAt[dedupeKey] = now;
  }
  const method = GLOBAL_TOAST_BY_TYPE[type] || GLOBAL_TOAST_BY_TYPE.error;
  if (!isToastReady()) {
    (toast[type] || toast.error)(message);
  } else {
    globalToast[method](message);
  }
};
